import '../../styles/components/custom-marker.scss';
const CustomMarker = ({
    maps,
    ...args
  }) => {
    class HTMLMapMarker extends maps.OverlayView {
      constructor() {
        super();
        this.latlng = args.latlng;
        this.html = args.html;
        this.mouseDownEvent = null;
        this.mouseUpEvent = null;
        this.unit = args.unit;
        //this.setMap(args.map);
      }
  
      createDiv() {
        this.div = document.createElement("div");
        this.div.style.position = "absolute";
        
        if (args.draggable) {
          this.setDraggable(true)
        }
          
        if (this.html && !args.appendNode) {
          this.div.innerHTML = this.html;
        }

        if (args.appendNode) {
          this.div.appendChild(args.appendNode);
        }

        maps.event.addDomListener(this.div, "click", event => {
          maps.event.trigger(this, 'click', event);
        });
      }

      attachMoveEvents() {
        this.mouseDownEvent = maps.event.addDomListener(this.div, 'mousedown', (e) => {
          this.div.style.cursor='move';
          this.div.className = 'custom-marker-house--dragging';
          args.map.set('draggable',false);
          this.set('origin',e);
          this.moveHandler = maps.event.addDomListener(this.get('map').getDiv(), 'mousemove', (e) => {
            
            if (!this.getProjection()) return;

            let origin = this.get('origin');
            let left   = origin.clientX-e.clientX,
                top    = origin.clientY-e.clientY,
                pos    = this.getProjection().fromLatLngToDivPixel(this.latlng);
            
            //this.latlng = this.getProjection().fromDivPixelToLatLng(new maps.Point(pos.x-left, pos.y-top));
            this.div.style.left = `${pos.x-left}px`;
            this.div.style.top = `${pos.y-top}px`;
          
          });
        }); 

        this.mouseUpEvent = maps.event.addDomListener(this.div,'mouseup',(e) => {
          this.map.set('draggable', true);
          this.div.style.cursor='default';
          this.div.classList.remove('custom-marker-house--dragging');
          maps.event.removeListener(this.moveHandler);
          let origin = this.get('origin');
          let left   = origin.clientX-e.clientX,
              top    = origin.clientY-e.clientY,
              pos    = this.getProjection().fromLatLngToDivPixel(this.latlng);
            
            this.latlng = this.getProjection().fromDivPixelToLatLng(new maps.Point((pos.x-left), (pos.y-top)));
            
            // Anropa callback när marker flyttas
            if (args.onMarkerMoved) {
                args.onMarkerMoved(this);
            }
        });
      }

      removeMoveEvents() {
        maps.event.removeListener(this.mouseDownEvent);
        maps.event.removeListener(this.mouseUpEvent);
      }

      setDraggable(draggable) {
        if (!this.div) return;
        this.div.draggable = draggable;

        if (draggable) {
          this.attachMoveEvents();
        } else {
          this.removeMoveEvents();
        }
        
      }
  
      appendDivToOverlay() {
        const panes = this.getPanes();
        panes.overlayImage.appendChild(this.div);
      }
  
      positionDiv() {
        const point = this.getProjection().fromLatLngToDivPixel(this.latlng);
        //let offset = 25;
        if (point) {
          this.div.style.left = `${point.x}px`;
          this.div.style.top = `${point.y}px`;
        }
      }
  
      draw() {
        if (!this.div) {
          this.createDiv();
          this.appendDivToOverlay();
        }
        this.positionDiv();
      }
  
      remove() {
        if (this.div) {
          this.div.parentNode.removeChild(this.div);
          this.div = null;
        }
      }
  
      getPosition() {
        return this.latlng;
      }
  
      getVisible() {
        return true;
      }

      getDraggable() {
        return false;
      }

      getGeoJSON() {
        const json = {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [this.latlng.lng(), this.latlng.lat()]
          },
          properties:{}
        }
        
        return json;
      }
    }
  
    return new HTMLMapMarker();
  };
  
  export default CustomMarker;
  